import { defineComponent as m, createBlock as l, openBlock as a, resolveDynamicComponent as c, mergeProps as r, unref as n, withCtx as s, renderSlot as d } from "vue";
import e from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Content/content.js";
import { useOUIAProps as u } from "../helpers/ouia.js";
const v = /* @__PURE__ */ m({
  name: "PfContent",
  __name: "Content",
  props: {
    component: { default: "div" },
    plainList: { type: Boolean },
    visited: { type: Boolean },
    editorial: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(p) {
    const t = p, i = u({ id: t.ouiaId, safe: t.ouiaSafe });
    return (o, f) => (a(), l(c(o.component), r(n(i), {
      class: [n(e).content, {
        [n(e).modifiers.visited]: o.visited,
        [n(e).modifiers.plain]: o.plainList && ["ul", "ol", "dl"].includes(o.component),
        [n(e).modifiers.editorial]: o.editorial,
        [n(e).content]: o.component === "div",
        [n(e).contentH1]: o.component === "h1",
        [n(e).contentH2]: o.component === "h2",
        [n(e).contentH3]: o.component === "h3",
        [n(e).contentH4]: o.component === "h4",
        [n(e).contentH5]: o.component === "h5",
        [n(e).contentH6]: o.component === "h6",
        [n(e).contentP]: o.component === "p",
        [n(e).contentA]: o.component === "a",
        [n(e).contentSmall]: o.component === "small",
        [n(e).contentBlockquote]: o.component === "blockquote",
        [n(e).contentPre]: o.component === "pre",
        [n(e).contentHr]: o.component === "hr",
        [n(e).contentUl]: o.component === "ul",
        [n(e).contentOl]: o.component === "ol",
        [n(e).contentDl]: o.component === "dl",
        [n(e).contentLi]: o.component === "li",
        [n(e).contentDt]: o.component === "dt",
        [n(e).contentDd]: o.component === "dd"
      }]
    }), {
      default: s(() => [
        d(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
export {
  v as default
};
